<template>
  <CreateUpdateCategoryForm />
</template>

<script setup lang="ts"></script>
